import React from "react";

import { Editor } from "@fronterahealth/frontera-ui-components/WYSIWYG/Editor";

interface StoredHtmlProps {
  html: string;
  className?: string;
}

// Markup an EHR stored (e.g. CentralReach rich-text descriptions), shown in the read-only
// WYSIWYG editor: Quill rebuilds it from its own formats (text, emphasis, lists, links),
// so scripts, handlers and styles in the stored HTML are never rendered.
export const StoredHtml: React.FC<StoredHtmlProps> = ({ html, className }) => (
  // The editor only reads initialContent on mount, so remount when the stored value changes.
  <Editor key={html} initialContent={html} readOnly toolbar={false} variant="ghost" className={className} />
);
